import React from 'react'
import { SVGIconProps } from 'commonTypes'
import CompoundsIcon from './CompoundsIcon'
import ReportIcon from './ReportIcon'
import SampleIcon from './SampleIcon'
import DetailedAnalysisIcon from './DetailedAnalysisIcon'
import ExpertIcon from './ExpertIcon'

export type MenuIconTypes =
    | 'Report'
    | 'Compounds'
    | 'Targets'
    | 'Alterations detected'
    | 'Detailed Analysis'
    | 'Experts Involved'

type MenuIconProps = SVGIconProps & {
    type: MenuIconTypes
}

const MenuIcons: React.FC<MenuIconProps> = ({ type, fill, ...props }) => {
    const renderIcon = (type: MenuIconTypes) => {
        switch (type) {
            case 'Compounds':
                return <CompoundsIcon fill={fill} {...props} />
            case 'Targets':
            case 'Alterations detected':
                return <SampleIcon fill={fill} {...props} />
            case 'Detailed Analysis':
                return <DetailedAnalysisIcon fill={fill} {...props} />
            case 'Experts Involved':
                return <ExpertIcon fill={fill} {...props} />
            case 'Report':
            default:
                return <ReportIcon fill={fill} {...props} />
        }
    }

    return renderIcon(type)
}

export default MenuIcons
